import { createSlice, nanoid } from "@reduxjs/toolkit";

const initialState = {
  tasks: [
    {
      id: "t1",
      projectId: "p1",
      boardId: "b1",
      title: "Set up project structure",
      description: "Create React app with Redux & routing",
      priority: "High",
      dueDate: "2025-12-10",
      assigneeId: "u1",
      status: "Pending",
    },
    {
      id: "t2",
      projectId: "p1",
      boardId: "b2",
      title: "Build Dashboard UI",
      description: "Create dashboard layout with sidebar",
      priority: "Medium",
      dueDate: "2025-12-15",
      assigneeId: "u2",
      status: "Pending",
    },
  ],
};

const tasksSlice = createSlice({
  name: "tasks",
  initialState,
  reducers: {
    addTask: {
      reducer(state, action) {
        state.tasks.push(action.payload);
      },
      prepare(task) {
        return {
          payload: {
            id: nanoid(),
            status: "Pending", // default
            ...task,
          },
        };
      },
    },

    updateTask(state, action) {
      const { id, updates } = action.payload;
      const index = state.tasks.findIndex((t) => t.id === id);
      if (index !== -1) {
        state.tasks[index] = { ...state.tasks[index], ...updates };
      }
    },

    deleteTask(state, action) {
      const id = action.payload;
      state.tasks = state.tasks.filter((t) => t.id !== id);
    },

    moveTask(state, action) {
      const { taskId, targetBoardId } = action.payload;
      const task = state.tasks.find((t) => t.id === taskId);
      if (task) {
        task.boardId = targetBoardId;
      }
    },

    // ⭐ Mark task completed
    markTaskDone(state, action) {
      const taskId = action.payload;
      const task = state.tasks.find((t) => t.id === taskId);
      if (task) {
        task.status = "Completed";
      }
    },
  },
});

export const {
  addTask,
  updateTask,
  deleteTask,
  moveTask,
  markTaskDone,
} = tasksSlice.actions;

export default tasksSlice.reducer;
